import { render, staticRenderFns } from "./DiningPromotion.vue?vue&type=template&id=ffa32c90&scoped=true&"
import script from "./DiningPromotion.vue?vue&type=script&lang=js&"
export * from "./DiningPromotion.vue?vue&type=script&lang=js&"
import style0 from "./DiningPromotion.vue?vue&type=style&index=0&id=ffa32c90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa32c90",
  null
  
)

export default component.exports